module.exports = __webpack_public_path__ + "img/index-about-bg-02.f902656a.png";